// extracted by mini-css-extract-plugin
export default {"triWrapper":"customer-list_triWrapper__N74E4","wrapper":"customer-list_wrapper__guLKi","icon":"customer-list_icon__iTWJX","w":"customer-list_w__hDgof"};